import React, {Component} from "react";
import PropTypes from "prop-types";
import { connect}  from "react-redux";
import { mueveSlider } from "../js/actions/index";
import "./hslider.scss";

function mapStateToProps(state){
	return {
		porcentaje:state.anatomia.porcentaje,
	};
}

function mapDispatchToProps(dispatch){
	return{
		mueveRaton: (dir) => dispatch(mueveSlider(dir)),
	};
}

class Slider extends Component{
	static propTypes = {
		porcentaje:PropTypes.number,
		mueveRaton:PropTypes.func,
		tipo:PropTypes.string,
	}
	mouseDown = (e)=>{
		this.coords = {
			x: e.pageX,
			y: e.pageY
		};
		document.addEventListener("mousemove", this.handleMouseMove);
		document.addEventListener("mouseup", this.handleMouseUp);
		if(e.preventDefault)
			e.preventDefault();
		else if(e.evt && e.evt.preventDefault)
			e.evt.preventDefault();
	}
	
	handleMouseMove = (e)=>{
		let xDiff = e.pageX - this.coords.x;
		let yDiff = e.pageY - this.coords.y;
		this.coords.x = e.pageX;
		this.coords.y = e.pageY;
		this.props.mueveRaton({x:xDiff,y:yDiff});
		if(e.preventDefault)
			e.preventDefault();
		else if(e.evt && e.evt.preventDefault)
			e.evt.preventDefault();
	}
	
	handleMouseUp = () => {
		document.removeEventListener("mousemove", this.handleMouseMove);
		document.removeEventListener("mouseup", this.handleMouseUp);
		this.coords = {};
	};
	render(){
		
		let posicion = 70*this.props.porcentaje;
		if(this.props.tipo === "H"){
			let style = {left:posicion+"%"};
			return <div style={style} id="fondoSlider" className="H"><div id="slider" onMouseDown={this.mouseDown}></div></div>;
		}else{
			let style = {top:posicion+"%"};
			return <div style={style} id="fondoSlider" className="V"><div id="slider" onMouseDown={this.mouseDown}></div></div>;
		}
	}
}
export default connect(mapStateToProps,mapDispatchToProps)(Slider);